import React, { useState, useEffect } from "react";
import { ReactComponent as SalesgearMark } from "Assets/logo/svg/icon.svg";
import { ReactComponent as SalesIntelMark } from "Global/Header/Icons/salesintelLogo.svg";

// The loader renders before the theme resolves, so brand off the host.
const isSalesIntelHost = () =>
  window.location.hostname === "prospectconnect.qa.salesintel.io" ||
  window.location.hostname === "prospectconnect.salesintel.io" ||
  window.location.hostname === "localhost";

// Staged, one-way copy: a fast boot shows only the pulsing mark; text appears
// (and escalates) only when the wait becomes long enough to warrant it.
const BOOT_STAGES = [
  { afterMs: 0, text: "" },
  { afterMs: 2000, text: "Loading your workspace..." },
  { afterMs: 6000, text: "Still working, fetching your account..." },
  {
    afterMs: 12000,
    text: "Taking longer than usual. Hang tight, or refresh if this persists.",
    delayed: true
  }
];

const BrandedBootLoader = () => {
  const [stageIdx, setStageIdx] = useState(0);

  useEffect(() => {
    const timers = BOOT_STAGES.slice(1).map((stage, index) =>
      setTimeout(() => setStageIdx(index + 1), stage.afterMs)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  const stage = BOOT_STAGES[stageIdx] || {};

  return (
    <div className="brandedBootLoader">
      {isSalesIntelHost() ? (
        <SalesIntelMark className="bootLogoMark" />
      ) : (
        <SalesgearMark className="bootLogoMark" />
      )}
      <div className="bootLoaderBar">
        <div className="bootLoaderBarFill"></div>
      </div>
      <div className="bootLoaderTextSlot">
        {stage.text && (
          <div
            key={stageIdx}
            className={`bootLoaderText ${stage.delayed ? "isDelayed" : ""}`}
          >
            {stage.text}
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandedBootLoader;
